import { UIStyleConstants } from "../../../Common/UIStyleConstants";

export class TreeRuleConstant {
    static DIFF_TRUE_X: number = 100;
    static DIFF_TRUE_Y: number = 0;

    static DIFF_FALSE_X: number = 0;
    static DIFF_FALSE_Y: number = 50;

    static LINE_COLOR: string = UIStyleConstants.BLUE_COLOR;

    static RIGHT_NODE_ARROW_OFFSET = 20;
    static BOTTOM_NODE_ARROW_OFFSET = 50;

    static SELECTED_NODE_BORDER_COLOR = UIStyleConstants.BLUE_COLOR;

    static DESIGN_SURFACE_ID = "TreeRule_designer";

    static DEFAULT_NODE_COLOR = UIStyleConstants.WHITE_COLOR;
    static DEFAULT_RESULT_NODE_COLOR = UIStyleConstants.GRAY_VERY_LIGHT_COLOR;

    // todo: why not used
    static TREE_RULE_CLEAR_COOKIE_KEY = "TreeRuleClearCookieKey";
}
